import { wrapVars } from './wrapVars';

/**
 * Оборачивает текст в процентах в span, если он не является атрибутом ссылки
 */
export const wrapTextInVars = (text: string) => {
  const parts = text.split(/(<a [^>]*>.*?<\/a>)/g);

  const linkContentRegexp = new RegExp('>(s*)(.*?)(s*)</a>');
  const result = parts
    .map((part) => {
      if (part.startsWith('<a ')) {
        // извлекаем содержимое ссылки
        const linkContentMatch = part.match(linkContentRegexp);

        if (linkContentMatch) {
          // Проверяем наличие переменной
          const linkContentWithVar = wrapVars(linkContentMatch[2]);

          // Восстанавливаем тег <a> с обработанным содержимым, добавляем извлеченные пробелы до и после ссылки
          return `${linkContentMatch[1]}${part.replace(
            linkContentRegexp,
            `>${linkContentWithVar}</a>`
          )}${linkContentMatch[3]}`;
        }
        return part;
      }
      // Если часть не является тегом <a>, заменяем переменные
      return wrapVars(part);
    })
    .join('');

  return result;
};
